// Header.js
import React, { useState, useRef, useEffect } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
// import QRCodeStyling from "qr-code-styling";
import Link1 from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
// import SortIcon from "@mui/icons-material/Sort";
import { ReactComponent as SortIcon } from "../../Assets/img/icons/Sort_Cards.svg";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import AddCircleIcon from '@mui/icons-material/AddCircle';
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { ReactComponent as PDFicon } from "../../Assets/img/icons/PDF icon.svg";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
// import QrcodeScan from '../../Assets/img/icons/QRcode Scanner.svg';
// import NeoinScan from '../../Assets/img/icons/Neoin-at-center.svg';
// import companylogo from '../../Assets/img/icons/Company-logo.svg';
// import NeoinQR from '../../Assets/img/icons/QR-with-Neoin.svg';
// import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
// import { Menu, MenuItem } from '@material-ui/core';
// import { makeStyles } from '@material-ui/core/styles';
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import {
  Box,
  Menu,
  MenuItem,
  IconButton,
  Grid,
  TextField,
  Button,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaCircleMinus } from "react-icons/fa6";
import { FaPlusCircle } from "react-icons/fa";
import { useQuantityContext } from "../QuantityContext";
import { FaStar } from "react-icons/fa";
// import { useUserDetailContext } from '../UserDetailContext';
import { ReactComponent as EditIcon } from "../../Assets/img/icons/edit-icon-figma.svg";
import { ReactComponent as DuplicateIcon } from "../../Assets/img/icons/Download-icon.svg";
import { ReactComponent as DigitalIcon } from "../../Assets/img/icons/email sign.svg";
import { ReactComponent as VirtualIcon } from "../../Assets/img/icons/Vitual Bg.svg";
// import { ReactComponent as Groupicon } from "../../Assets/img/icons/Group Contact.svg";
// import { ReactComponent as Addcontact } from "../../Assets/img/icons/Vector.svg";
// import { ReactComponent as Addevent } from "../../Assets/img/icons/Vector1.svg";
// import { LiaDownloadSolid } from "react-icons/lia";
import { ReactComponent as FileDownloadIcon } from "../../Assets/img/icons/Download-breadcrumb.svg";
import { useCardDetailContext } from "../CardDetailContext";
import { useUserDetailContext } from "../UserDetailContext";
// import { FaArrowDownLong } from "react-icons/fa6";
// import { FaArrowUp } from "react-icons/fa";
import { ReactComponent as FaArrowUp } from "../../Assets/img/icons/Arrow Upward.svg";
import { ReactComponent as FaArrowDownLong } from "../../Assets/img/icons/Arrow  Downward.svg";
import useApi from "../Utilities/useAPI";
// import AttachDoc from "./Cards/CardEditParts/AttachDoc";
import { ReactComponent as FilterIcon } from "../../Assets/img/icons/filter-icon.svg";
import html2canvas from "html2canvas";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { ReactComponent as GridIconSymb } from "../../Assets/img/icons/Grid-3-icon.svg";
import { ReactComponent as CardView } from "../../Assets/img/icons/Card View Group.svg";
import { ReactComponent as GroupCard } from "../../Assets/img/icons/family group.svg";
import { ReactComponent as Status } from "../../Assets/img/icons/Analytics.svg";
import {
  FilterOtherJobs,
  setJobViewMode,
} from "../../Redux/Reducers/JobReducer";
import { sortJobs } from "../../Redux/Reducers/JobReducer";
import { filterJobs } from "../../Redux/Reducers/JobReducer";

import {
  getAllCardDetailsReducer,
  getAllCardInfoReducer,
} from "../../Redux/Reducers/CardReducer";
import { postRevokeAccountReducer } from "../../Redux/Reducers/OnboardingReducer";
import { getTemplateById, sendLetterforSignature } from "../../Redux/Reducers/letterHeadReducer.ts";
import { useLetterhead } from "./letterhead/hooks/useLetterhead.ts";
import { extractErrors, letterSchema } from "./letterhead/services/letterValidationSchema.ts";
// import { sendSigningLinkAPIHelper } from "../..Redux/helpers/letterheadAPI.ts";

// import { useDispatch } from "react-redux";

const NewBreadcrumb = () => {
  const User_ID = localStorage.getItem("objectId");

  const { callApiFunction, loading, error } = useApi();
  // const [jobView, setJobView] = useState("List View");
  const [jobSortPopup, setJobSortPopup] = useState(false);
  const [jobViewPopup, setJobViewPopup] = useState(false);
  const [jobSortOrder, setJobSortOrder] = useState("descending");
  const [jobDateOrder, setJobDateOrder] = useState("descending");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();

  let doc = location.state?.docType;
  // const storedUserDetails = JSON.parse(localStorage.getItem("userDetails")); // Parse JSON

  const {
    templates,
    isLoading,
    isEditMode,
    companyProfile,
    letterState: state,
    updateLetterState: updateState,
    processedTemplate,
    isSignatureModalOpen,
    setIsSignatureModalOpen,
    isESignModalOpen,
    setIsESignModalOpen,
    handleSaveLetter,
    handleESignSuccess,
    setLetterState,
    iquiqueCode,
    isSendingEmail,
  } = useLetterhead();
  const [errors, setErrors] = useState({});
  // console.log("stateNNNNNNNNNNNNNNN", state)

  const jobView =
    useSelector((state) => state?.jobs?.viewMode) === "grid"
      ? "Grid View"
      : "List View";
  const rawUserDetails = localStorage.getItem("userDetails");
  const storedUserDetails =
    rawUserDetails && rawUserDetails !== "undefined"
      ? JSON.parse(rawUserDetails)
      : null;

  const [toggleBtn, setToggleBtn] = useState(
    storedUserDetails?.is_delete_requested
  );

  useEffect(() => {
    if (storedUserDetails) {
      setToggleBtn(storedUserDetails.is_delete_requested);
    }
  }, [storedUserDetails]);
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [filters, setFilters] = useState({
    searchKeyword: "",
    dept_type: "",
    experience: "",
    edu_level: "",
    role: "",
    location: "",
    mode: "",
  });
  const popupRef = useRef(null);
  const Jobs = useSelector((state) => state?.jobs?.postedJobsData);
  const postedJobs = Jobs?.posted_jobs;
  const allJobs = useSelector((state) => state.jobs.allJobs);
  const singlePostedJob = useSelector((state) => state?.jobs?.singlePostedJob);
  const letterHead = useSelector((state) => state.letterHead.templates) || []
  // const letterHead =  []
  const singleJob = singlePostedJob?.job;

  // console.log("letterHeadletterHead", letterHead)

  const { handleSuccess } = useQuantityContext();

  const [daysRemaining, setDaysRemaining] = useState(null);

  useEffect(() => {
    // Get user details from localStorage
    // const storedUserDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");
    const rawUserDetails = localStorage.getItem("userDetails");
    const storedUserDetails =
      rawUserDetails && rawUserDetails !== "undefined"
        ? JSON.parse(rawUserDetails)
        : null;

    if (storedUserDetails?.date_of_deletion) {
      const deletionDate = new Date(storedUserDetails?.date_of_deletion); // Convert to Date object
      const currentDate = new Date(); // Get current date

      // Calculate the difference in milliseconds and convert to days
      const timeDifference = deletionDate - currentDate;
      const daysLeft = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

      setDaysRemaining(daysLeft);
    }
  }, [storedUserDetails]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowFilterPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Filter handler
  const handleFilterChange = (filterType, value) => {
    const newFilters = {
      ...filters,
      [filterType]: filters[filterType] === value ? "" : value,
    };

    setFilters(newFilters);
    dispatch(filterJobs(newFilters)); // Dispatch to Redux
  };

  const handleOtherJobsFilterChange = (filterType, value) => {
    const updatedFilters = {
      ...filters,
      [filterType]: filters[filterType] === value ? "" : value, // Toggle filter
    };

    // Update local state
    setFilters(updatedFilters);

    // Dispatch with updated filters
    dispatch(FilterOtherJobs(updatedFilters));

    // Log for debugging
    console.log("Updated filters:", updatedFilters);
  };

  const {
    cardDetails,
    CardStyles,
    CardQrStyles,
    SocialLinks,
    ContactStyles,
    AttachDocs,
    updateCardDetails,
    updateCardStyles,
    updateContactStyles,
    updateCardQrStyles,
    updateSocialLinks2,
  } = useCardDetailContext();

  const { cards, userDetails } = useUserDetailContext();
  // console.log("CARDSSSSSS", cards[0]);
  // const [Logo, setcompanyLogo] = useState('');
  // const [name, setName] = useState("QRCode");
  // const [url, setUrl] = useState(`${process.env.REACT_APP_CARD_URL}/digital-identity/${cardDetails?.CardName}/${User_ID}`);


  // const { userDetails } = useUserDetailContext();
  const {
    quantity,
    setQuantity,
    sortOrder,
    setSortOrder,
    sortDateOrder,
    setSortDateOrder,
    isEnabledCCE,
    setIsEnabledCCE,
    latestDateOrder,
    setlatestDateOrder,
    ContactView,
    setContactsView,
    FilterOpen,
    handleClickFilter,
    activeGrpName,
    GroupCardView,
    setGroupCardView,
    handleCardClick,
  } = useQuantityContext();

  const handleSwitchChange = (event) => {
    setIsEnabledCCE(event.target.checked);
  };

  const handleIncrement = () => {
    if (quantity < 2) {
      setQuantity((prevQuantity) => prevQuantity + 1);
    }
  };

  // const dispatch = useDispatch();

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity((prevQuantity) => prevQuantity - 1);
    }
  };
  const [PopupSortItem, setPopupSortItem] = useState(false);
  const handleSortClick = () => {
    setPopupSortItem(!PopupSortItem);
  };

  const [ListViewPopup, setListViewPopup] = useState(false);
  const handleContactView = () => {
    setListViewPopup(!ListViewPopup);
  };

  const handleChangeView = (Viewtype) => {
    setContactsView(Viewtype);
  };
  const handleFavClick = () => {
    navigate("/cards");
  };

  const apiKey = process.env.REACT_APP_API_KEY; // actual API key
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };

  const currentUrl = window.location.href;
  const CardName = currentUrl.split("/").pop();

  const navigate = useNavigate();
  const handleClickEmail = () => {
    // Perform any actions you need before navigation
    const props = {
      someProp: CardName,
    };
    // Navigate to the SignatureComponent with state
    navigate("/digital-identity", { state: props });
  };
  const handleClickVirtualB = () => {
    navigate("/VirtualBackground");
  };

  const [deleteConfirm, setdeleteConfirm] = useState(false);
  const [password, setPassword] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [openRevoke, setOpenRevoke] = useState(false);

  const handleRevoke = () => {
    setOpenRevoke(true);
  };
  const handleRevokeAccount = async () => {
    try {
      const payload = {
        password: password,
      };
      const response = await dispatch(postRevokeAccountReducer(payload));
      console.log("Revoke response", response);
      if (response?.payload?.statusCode === 200) {
        const userResponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/user`,
          {
            headers: {
              ...headers,
              Authorization: `Bearer ${objectId}`,
            },
          }
        );
        const userData = userResponse?.data?.data?.user;
        localStorage.setItem("userDetails", JSON.stringify(userData));
        setOpenRevoke(false);
        handleSuccess("Account revoked successfully.");
        setToggleBtn(userData?.is_delete_requested);
      } else {
        setToggleBtn(true);
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };
  const handleDeleteCard = async () => {
    try {
      const loginResponse = await callApiFunction("checkPassword", {
        email: userDetails.email,
        password,
        loginMethod: "username_password",
        loginType: "web",
      });

      if (loginResponse?.statusCode === "1000") {
        console.log("Password verified successfully");

        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/card/delete-card`,
            {
              headers: headers,
              params: {
                CardName: CardName,
                CardType: cardDetails.CardType,
              },
            }
          );
          // console.log("response", response);

          if (response?.data?.status === "SUCCESS") {
            console.log("Card details deleted successfully");
            setdeleteConfirm(false);
            window.location.href = "/cards";

            await dispatch(getAllCardDetailsReducer());

            await dispatch(getAllCardInfoReducer());
          } else {
            console.log("Failed to delete card details");
            seterrorMessage("Failed to delete the card.");
          }
        } catch (error) {
          console.error("Error deleting card details:", error);
          seterrorMessage("Failed to delete the card.");
        }
      } else {
        seterrorMessage("Incorrect password. Please try again.");
      }
    } catch (error) {
      console.error("Error logging in:", error);
      seterrorMessage("Wrong Password, Try again");
    }
  };

  const getBreadcrumbLabel = (asText = false) => {
    const currentPath = location.pathname;

    switch (true) {
      case currentPath === "/home":
        return "Home";
      case currentPath === "/":
        return "Home";
      case currentPath === "/dashboard":
        return "Dashboard";
      case currentPath === "/digital-identity":
        return "Digital Identity";
      case currentPath === "/digital-identity-paid":
        return "Digital Identity Paid";
      case currentPath === "/calendar":
        return "Calendar";
      case currentPath === "/cards":
        return "Cards";
      case currentPath === "/applicant-saved-jobs":
        return "Applicant saved Jobs";
      case currentPath === "/community":
        return "Explore";
      case currentPath === "/personal-events":
        return "Personal Events";
      case currentPath === "/professional-events":
        return "Professional Events";
      case currentPath === "/community-dashboard":
        return "Dashboard";
      case currentPath === "/community-volunteer-dashboard":
        return "Volunteer Dashboard";
      // case currentPath === "/all-candidatesinfo":
      //   return "All candidates";
      // case currentPath === "/favourite_contacts":
      //   return "Favourite Contacts";
      // case currentPath === "/alljobs":
      //   return "Posted jobs";
      case currentPath === "/jobopening":
        return "View All Jobs";
      case currentPath === "/analytics-dashboard":
        return "Recruitment Dashboard";
      // case currentPath === "/candidate-progress":
      //   return "Analytics Dashboard";
      // case currentPath.startsWith("/recruitment-Status"):
      //   return "Job Analytics";
      case currentPath.startsWith("/applicant-page"):
        return "Applicants Status";
      case currentPath.startsWith("/documents"):
        return "Documents";
      case currentPath.startsWith("/view-recruiter-offer-letter"):
        return "View offer letter";
      case currentPath.startsWith("/job-description"):
        return "Job Description";
      case currentPath.startsWith("/posted-job-description"):
        return "Job Description";
      case currentPath.startsWith("/explore/events"):
        return "Event Description";
      case currentPath.startsWith("/explore/feeds"):
        return "Feeds Description";
      case currentPath.startsWith("/contacts/folder"):
        return "contacts";
      case currentPath.startsWith("/call"):
        return "video call";
      case currentPath.startsWith("/view-applicant-offer-letter"):
        return "view offer letter";
      case currentPath.startsWith("/audit-logs"):
        return "Audit Logs";
      case currentPath === "/applicant":
        return "Applied Jobs";
      case currentPath === "/job-description":
        return "Job Description";
      case currentPath === "/coming-soon":
        return "Coming soon";
      case currentPath === "/favourite-jobs":
        return "Saved Jobs";
      case currentPath === "/compose-letter":
        return "Compose Letter";
      case currentPath === "/product-marketplace":
        return "Products";
      case currentPath === "/create-template":
        return "Create Template";
      case currentPath === "/product-single-page":
        return asText ? (
          "Products / Product Details"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/product-marketplace">
              Products
            </Link1>{" "}
            / Product Details
          </>
        );
      case currentPath === "/favourite_contacts":
        return asText ? (
          "Cards / Favourites"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/contacts">
              Contact
            </Link1>{" "}
            / Favourites
          </>
        );

      case currentPath === "/candidate-progress":
        return asText ? (
          "Analytics Dashboard/candidate progress"
        ) : (
          <>
            <Link1
              underline="hover"
              color="inherit"
              href="/analytics-dashboard"
            >
              Analytics Dashboard
            </Link1>{" "}
            / candidate progress
          </>
        );
      case currentPath === "/alljobs":
        return asText ? (
          "Analytics Dashboard/Posted Jobs"
        ) : (
          <>
            <Link1
              underline="hover"
              color="inherit"
              href="/analytics-dashboard"
            >
              Analytics Dashboard
            </Link1>{" "}
            / Posted Jobs
          </>
        );
      case currentPath === "/recruitment-Status":
        return asText ? (
          "Posted Jobs/Job Analytics"
        ) : (
          <>
            <Link1
              underline="hover"
              color="inherit"
              href="/alljobs"
            >
              Posted Jobs
            </Link1>{" "}
            / Job Analytics
          </>
        );

      case currentPath === "/all-candidatesinfo":
        return asText ? (
          "Analytics Dashboard / All candidates"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/recruitment-Status">
              Analytics Dashboard
            </Link1>{" "}
            /All candidates
          </>
        );
      case currentPath === "/access-logs":
        return asText ? (
          "Dashboard / Access Logs"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/community-dashboard">
              Dashboard
            </Link1>{" "}
            /Access Logs
          </>
        );

      case currentPath?.startsWith("/candidateSingle-page"):
        return asText ? (
          `${singleJob?.role} / candidate`
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/recruitment-Status">
              {singleJob?.role}
            </Link1>{" "}
            / candidate
          </>
        );


      case currentPath?.startsWith("/event/"):
        return asText ? (
          'Dashboard / volunteer Details'
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/community-dashboard">
              Dashboard
            </Link1>{" "}
            / volunteer Details
          </>
        );


      case /^\/card\/\w+/.test(currentPath):
        return asText ? (
          "Cards / Card Detailed View"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/cards">
              Cards
            </Link1>{" "}
            / Card Detailed View
          </>
        );

      case currentPath === "/Favourites":
        return asText ? (
          "Cards / Favourites"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/cards">
              Cards
            </Link1>{" "}
            / Favourites
          </>
        );
      case currentPath === "/create-card":
        return asText ? (
          "Cards / Create New card"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/cards">
              Cards
            </Link1>{" "}
            / Create New card
          </>
        );

      case currentPath === "/edit-card":
        return asText ? (
          "Cards / Edit card"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/cards">
              Cards
            </Link1>{" "}
            / Edit card
          </>
        );
      // case currentPath === "/edit-card":
      //   return "Cards / Edit card";
      case currentPath === "/contacts":
        return "Contacts";
      case currentPath === "/Unverified_Contacts":
        return "Non-Verified Contacts";
      case currentPath === "/connect-chat":
        return "Chats";
      case currentPath === "/AllContacts_groups":
        return asText ? (
          "Contacts / All Contacts"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/contacts">
              Contacts
            </Link1>{" "}
            / All Contacts
          </>
        );
      // return "Groups";
      case currentPath === "/myprofile":
        return "My Profile";
      case currentPath === "/myprofile/create-video-resume":
        return (
          <>
            <Link1 underline="hover" color="inherit" href="/myprofile">
              My Profile
            </Link1>{" "}
            / Video Resume
          </>
        );
      case currentPath === "/my-feeds":
        return asText ? (
          "Explore / My Posts"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/community">
              Explore
            </Link1>{" "}
            / My Posts
          </>
        );

      case currentPath === "/profile/:userId":
        return "Shared Profile View";
      case currentPath === "/AllBusinessCard":
        return "Business Cards";
      case currentPath === "/connect":
        return asText ? (
          "Contacts / Add to Contacts"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/contacts">
              Contacts
            </Link1>{" "}
            / Add to Contacts
          </>
        );

      case currentPath === "/AllGroup_details": // Match /groupContacts/:id where :id is a number
        return asText ? (
          `Contact / All Groups`
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/contacts">
              Contact
            </Link1>{" "}
            / All groups
          </>
        );
      case currentPath === "/edit_group":
        return "Edit Group Details";
      case currentPath === "/create_group":
        return asText ? (
          "Contacts / Create Group Card"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/contacts">
              Contacts
            </Link1>{" "}
            / Create Group Card
          </>
        );
      case /^\/groupContacts\/\d+$/.test(currentPath): // Match /groupContacts/:id where :id is a number
        return asText ? (
          `All Groups / ${activeGrpName}`
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/AllGroup_details">
              All groups
            </Link1>{" "}
            / {activeGrpName}
          </>
        );
      case /^\/familyCard\/\d+$/.test(currentPath): // Match /familyCard/:id where :id is a number
        return asText ? (
          "Cards / Group Card"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/cards">
              Cards
            </Link1>{" "}
            / Group Card
          </>
        );

      case currentPath === "/countrySelecting":
        return " KYC";

      case currentPath === "/verifyAdhar":
        return asText ? (
          " KYC / AadharCard Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>{" "}
            / AadharCard Verification
          </>
        );

      case currentPath === "/verifyEPF":
        return asText ? (
          " KYC/ EPF Account Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>{" "}
            / EPF Account Verification
          </>
        );

      case currentPath === "/verifypancard":
        return asText ? (
          " KYC/PAN Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>{" "}
            / PAN Verification
          </>
        );

      case currentPath === "/verifyresidential":
        return asText ? (
          " KYC/ Residentical Address Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>{" "}
            / Residentical Address Verification
          </>
        );

      case currentPath === "/VerifyresidentialForm":
        return asText ? (
          " KYC/ Residentical Address Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>{" "}
            / Residentical Address Verification
          </>
        );

      case currentPath === "/verifypassport":
        return asText ? (
          "  KYC/Passport Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>{" "}
            /Passport Verification
          </>
        );
      case currentPath === "/verifyDL":
        return asText ? (
          "KYC/ Driveing License Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              /KYC
            </Link1>
            / Driveing License Verification
          </>
        );

      case currentPath === "/verifyresidential":
        return asText ? (
          "KYC/ Residentical Address Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>
            / Residentical Address Verification
          </>
        );

      case currentPath === "/Verifyvisa":
        return asText ? (
          " KYC/ Visa Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>
            / Visa Verification
          </>
        );

      case currentPath === "/verifybirthday":
        return asText ? (
          " KYC/ Birth Certificate Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>
            / Birth Certificate Verification
          </>
        );

      case currentPath === "/verifyNric":
        return asText ? (
          " KYC/ NRIC Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>
            / NRIC Verification
          </>
        );

      case currentPath === "/verifyNric":
        return asText ? (
          " KYC/ NRIC Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>
            / NRIC Verification
          </>
        );

      case currentPath === "/VerifyNricForm":
        return asText ? (
          " KYC/ NRIC Verification"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>
            / NRIC Verification
          </>
        );
      case currentPath === "/addadminEditGroup":
        return asText ? (
          "  Edit Group Details / Add Admin "
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/edit_group">
              Edit Group Details
            </Link1>{" "}
            / Add Admin
          </>
        );

      case currentPath === "/Card_ConnectedMember/Student":
        return asText ? (
          " Contact/Student  "
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/contacts">
              Contacts
            </Link1>{" "}
            / Student
          </>
        );

      case currentPath === "/Card_ConnectedMember/Personal":
        return asText ? (
          " Contact/Personal  "
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/contacts">
              Contacts
            </Link1>{" "}
            / Personal
          </>
        );

      case currentPath === "/Card_ConnectedMember/Professional":
        return asText ? (
          " Contact/Professional  "
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/contacts">
              Contacts
            </Link1>{" "}
            / Professional
          </>
        );

      case currentPath === "/id":
        return "ID / Private ID";

      case currentPath === "/notes":
        return "Secured Folders";

      // match dynamic /notes/:id path
      case /^\/notes\/\w+/.test(currentPath):
        return (
          <>
            <Link1 underline="hover" color="inherit" href="/notes">
              Secured Folders
            </Link1>{" "}
            / Notes
          </>
        );
      case currentPath === "/userDetailedInfo":
        return asText ? (
          "Contacts /Group Member"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/contacts">
              Contacts
            </Link1>{" "}
            / Group Member
          </>
        );
      case currentPath === "/VirtualBackground":
        return "Virtual Background";
      // case currentPath === "/connectedContacts":
      //   return "Connected contacts";
      // case currentPath === "/addPeopletoGroup":
      //   return "Connected contacts";
      case currentPath === "/connectedContacts":
        return asText ? (
          "Createing Group /Connected contacts"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/create_group">
              Createing Group
            </Link1>{" "}
            / Connected contacts
          </>
        );
      case currentPath === "/addPeopletoGroup":
        return asText ? "/Connected contacts" : <>Connected contacts</>;
      case currentPath === "/profile":
        return "Shared Profile";
      case currentPath === "/delete-account":
        return "Delete Account";
      case currentPath === "/familydashboard":
        return "Family Dashboard";
      case currentPath === "/discount":
        return "Offers & Discounts";
      case currentPath === "/verify-docs":
        return asText ? (
          "/verify-docs"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/countrySelecting">
              KYC
            </Link1>{" "}
            / {displayDoc}
          </>
        );
      case currentPath === "/personalitytest":
        return asText ? (
          "/personalitytest"
        ) : (
          <>
            {/* <Link1 underline="hover" color="inherit" href="/home">
              Home page
            </Link1>{" "} */}
            Personality Test
          </>
        );

      case currentPath === "/personalDetails":
        return asText ? (
          "/personalitytest"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/personalitytest">
              Personality Test
            </Link1>{" "}
            / Personality Result
          </>
        );

      case currentPath === "/personalitySaboteur":
        return asText ? (
          "/personalitySaboteur"
        ) : (
          <>
            <Link1 underline="hover" color="inherit" href="/personalitytest">
              Personality Test
            </Link1>{" "}
            / Personality Saboteur
          </>
        );

      case currentPath === "/learningandcertifiate":
        return "Neoin Learning";
      default:
        return "Unknown";
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [OpenDownloadOption, setOpenDownloadOption] = useState(false);
  const handleOpenDownload = () => {
    setOpenDownloadOption(!OpenDownloadOption);
  };
  const closeDownloadOption = () => {
    setOpenDownloadOption(false);
  };

  const DownloadOptionPdf = () => {
    const qrCodeContainer = document.getElementById("qr-code-ref");

    html2canvas(qrCodeContainer, { useCORS: true }) // Ensure CORS is enabled
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png"); // Try PNG format
        const pdf = new jsPDF();
        pdf.addImage(imgData, "PNG", 10, 10, 100, 100); // Adjust dimensions if needed
        pdf.save(userDetails.name + "_" + cardDetails.CardName + ".pdf");
        setOpenDownloadOption(false);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };
  const DownloadOptionImage = () => {
    const qrCodeContainer = document.getElementById("qr-code-ref");

    html2canvas(qrCodeContainer, { useCORS: true }) // Ensure CORS is enabled
      .then((canvas) => {
        // Convert the canvas to a Blob and then download the image
        canvas.toBlob((blob) => {
          if (blob) {
            saveAs(blob, `${userDetails.name}_${cardDetails.CardName}.png`); // Save as PNG file
          } else {
            console.error("Failed to convert canvas to Blob");
          }
        }, "image/png");
        setOpenDownloadOption(false);
      })
      .catch((error) => {
        console.error("Error downloading image:", error);
      });
  };

  const handleLatestUpdate = () => {
    if (latestDateOrder === null) {
      setlatestDateOrder("latestDate");
    } else {
      setlatestDateOrder(null);
    }
  };

  const [duplicateCardopen, setDuplicateCardopen] = useState(false);
  const [newCardName, setNewCardName] = useState("");
  const [errorMessage2, setErrorMessage2] = useState("");

  const sendCardDataToDuplicate = async (newCardName, category) => {
    if (!category) {
      // This is to Check in Extreme Condition- if Card Type not Coming

      setErrorMessage2("Something Wrong, Card Type is not there");
      return;
    }
    const modifiedPayload = {
      ...AttachDocs,
      card_name: newCardName,
      images: AttachDocs.images.map((attachment) => ({
        document_name: attachment.name,
        size: attachment.size,
        date: attachment.date,
        document_type: attachment.type,
        public_url: attachment.data, // Corresponds to public_url
        file_cat: attachment.fileCat, // Corresponds to file_cat
        file_id: attachment.fileId, // Corresponds to file_id
        showQR: attachment.showQR, // Corresponds to showQR
        is_visible: attachment.visible, // Corresponds to is_visible
        is_verified: false, // Default value
        is_public: false, // Default value
      })),
      videos: AttachDocs.videos.map((attachment) => ({
        document_name: attachment.name,
        size: attachment.size,
        date: attachment.date,
        document_type: attachment.type,
        public_url: attachment.data,
        file_cat: attachment.fileCat,
        file_id: attachment.fileId,
        showQR: attachment.showQR,
        is_visible: attachment.visible,
        is_verified: false,
        is_public: false,
      })),
      others: AttachDocs.others.map((attachment) => ({
        document_name: attachment.name,
        size: attachment.size,
        date: attachment.date,
        document_type: attachment.type,
        public_url: attachment.data,
        file_cat: attachment.fileCat,
        file_id: attachment.fileId,
        showQR: attachment.showQR,
        is_visible: attachment.visible,
        is_verified: false,
        is_public: false,
      })),
    };

    // Combine all details into one object
    const AllDetailsOfCard = {
      userDetails: {
        card_mobile: userDetails.phone || "",
        email: userDetails.email,
        card_type: category,
        card_name: newCardName,
      },
      cardDetails: {
        ...cardDetails,
        CardName: newCardName,
        CardType: category,
      },
      CardStyles: {
        ...CardStyles,
        CardName: newCardName,
        CardType: category,
      },
      CardQrStyles: {
        ...CardQrStyles,
        CardName: newCardName,
        CardType: category,
      },
      SocialLinks: {
        ...SocialLinks,
        CardName: newCardName,
        card_type: category,
      },
      ContactStyles: {
        ...ContactStyles,
        CardName: newCardName,
        card_type: category,
      },
      AttachDocs: modifiedPayload,
    };
    console.log("ALL Details", AllDetailsOfCard);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/card/duplicateTheCard`,
        AllDetailsOfCard,
        {
          headers,
        }
      );

      console.log("Success:", response.data);
      return response;
    } catch (error) {
      console.error("Error while sending card data:", error);
      throw error; // Re-throw the error to handle it in the calling function
    } finally {
      window.location.href = "/cards";
    }
  };

  const handleDuplicateCard = async () => {
    // Trim the newCardName first and store it in a local variable
    const trimmedCardName = newCardName.trim();

    // Update the state with the trimmed value
    setNewCardName(trimmedCardName);

    // Perform the necessary validations on the trimmed value
    if (trimmedCardName === "") {
      setErrorMessage2("Card name cannot be empty");
      return;
    }
    if (
      cards
        .map((card) => card.toLowerCase())
        .includes(trimmedCardName.toLowerCase())
    ) {
      setErrorMessage2("Card name should be unique");
      return;
    }

    if (!/^[a-zA-Z\s]*$/.test(trimmedCardName)) {
      setErrorMessage2(
        "Card Name should not contain numbers or special characters"
      );
      return;
    }

    if (trimmedCardName.length > 18) {
      setErrorMessage2("Card Name must be 18 characters or less.");
      return;
    }

    const invalidCardNames = ["Personal", "Professional", "Student", "GenZ"];
    if (
      cards.includes(trimmedCardName) ||
      invalidCardNames.includes(trimmedCardName)
    ) {
      setErrorMessage2(
        "Card name should be unique and not one of the reserved names"
      );
      return;
    }

    let category = cardDetails?.CardType; //Initialization Changed According If it is Customize_

    // Update card details and other properties with the trimmed card name
    updateCardDetails({ CardName: trimmedCardName });
    updateCardStyles({ CardName: trimmedCardName });
    updateCardQrStyles({ CardName: trimmedCardName });
    updateSocialLinks2({ CardName: trimmedCardName });
    updateContactStyles({ CardName: trimmedCardName });

    if (cardDetails?.CardType?.startsWith("Customize_")) {
      updateCardDetails({ CardType: cardDetails?.CardType });
      updateCardStyles({ CardType: cardDetails?.CardType });
      updateCardQrStyles({ CardType: cardDetails?.CardType });
      updateSocialLinks2({ card_type: cardDetails?.CardType });
      updateContactStyles({ card_type: cardDetails?.CardType });
    } else {
      category = "Customize_" + cardDetails?.CardType;
      updateCardDetails({ CardType: category });
      updateCardStyles({ CardType: category });
      updateCardQrStyles({ CardType: category });
      updateSocialLinks2({ card_type: category });
      updateContactStyles({ card_type: category });
    }

    setDuplicateCardopen(false);

    try {
      // Pass the trimmed card name to the sendCardDataToDuplicate function

      await sendCardDataToDuplicate(trimmedCardName, category);
    } catch (error) {
      setErrorMessage2(`Failed to update card details: ${error.message}`);
    }
  };

  const docLabels = {
    aadhaar: "Aadhaar",
    "pan-card": "PAN",
    "driving-license": "Driving License",
  };

  const displayDoc = docLabels[doc] || doc;



  // const handleSendSignature = async (template) => {
  //   if (!template) {
  //     console.log('No template selected', template);


  //             // toast.success(`Secure signing links successfully sent!`);
  //     return;
  //   }
  //   console.log('Sending signature for template:', template);
  //     await  dispatch(sendLetterforSignature(finalLetterId, { companyName: template.TemplateIdentities[0]?.field_value|| "Our Company", frontendUrl: window.location.origin, subject: template.template_name }))  
  //   console.log('Template ID:', template.template_id);
  //   // Your logic here
  // };

  const validateAndSubmit = async (actionType) => {
    // Specific check for Send Final Email
    // console.log("IAM OUTSIDE")
    // if (actionType === 'SEND_LINK' && !state.recipientEmail) {
    if (actionType === 'SEND_LINK' && !state?.signatories[0]?.email) {
      // console.log("IAM OUTSIDE, final call")
      alert("Please provide a recipient email address before sending the final document.");
      return;
    }
    // console.log("IAM AFTER function skcbjkjsckjscskjckjs")
    try {
      setErrors({});
      // Validate the rest of the form (subject, body, etc.)
      // await letterSchema.validate(state, { abortEarly: false });

      // Pass the specific action ('SAVE', 'SEND_FINAL', or 'SEND_LINK') to the hook
      handleSaveLetter(actionType);
      // console.log("IAM AFTER function")
    } catch (err) {
      const validationErrors = extractErrors(err);
      // console.log("IAM AFTER function", err)
      setErrors(validationErrors);
    }
  };



  const getRightSideIcon = (breadcrumb) => {
    switch (breadcrumb) {
      case "Home":
        return (
          <>
            <div className="d-flex align-item-center">
              {toggleBtn ? (
                <div
                  className="m-2 d-flex flex-row  align-items-center fw-bold "
                  style={{ padding: "10px", fontWeight: 600 }}
                >
                  <p className="mb-0 mt-1 pe-1">
                    {" "}
                    Your account is scheduled for deletion in{" "}
                    {daysRemaining || 30} days.
                  </p>
                  <Button
                    sx={{
                      color: "white",
                      width: "214px",
                      height: "20px",
                      padding: "15px 25px",
                      backgroundColor: "#0044c6",
                      fontWeight: 300,
                      size: "1rem",
                      "&:hover": {
                        backgroundColor: "#0044c6", // No color change
                      },
                    }}
                    onClick={handleRevoke}
                  >
                    REVOKE DEACTIVATION?
                  </Button>
                </div>
              ) : (
                ""
              )}
              {openRevoke && (
                <div className="lightbox-overlay">
                  <div className="lightbox-content p-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <h6
                        className="mb-0"
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "black",
                        }}
                      >
                        Do you want to Revoke this Account?
                      </h6>
                      <IconButton onClick={() => setOpenRevoke(false)}>
                        <CloseRoundedIcon />
                      </IconButton>
                    </div>
                    <Typography variant="body2" className="text-muted">
                      {" "}
                      By revoking your account, you can stay connected with your
                      friends and connections.
                    </Typography>

                    <div className="mt-3">
                      <Grid container>
                        <Grid item xs={12}>
                          <TextField
                            variant="outlined"
                            label="Type Password"
                            fullWidth
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </Grid>
                      </Grid>
                    </div>

                    {errorMessage && (
                      <Typography variant="body2" color="error">
                        {errorMessage}
                      </Typography>
                    )}

                    <div className="d-flex justify-content-end">
                      <Button
                        onClick={() => setOpenRevoke(false)}
                        className="mx-2 mt-2"
                      >
                        CANCEL
                      </Button>
                      <Button
                        onClick={handleRevokeAccount}
                        className="delete-button_configuration mt-2"
                      >
                        REVOKE
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        );
      case "Cards":
        return (
          <>
            <div className="div-min-max me-3 d-flex align-items-center justify-content-around">
              <div
                className={`iconBreadcrumb flex-center ms-0 ${quantity === 1 ? "disable" : ""
                  }`}
                onClick={handleDecrement}
              >
                <FaCircleMinus className="icon-color" />
              </div>
              <div className="div">{quantity}x</div>
              <div
                className={`iconBreadcrumb flex-center ms-0 ${quantity === 2 ? "disable" : ""
                  }`}
                onClick={handleIncrement}
              >
                <FaPlusCircle className="icon-color" />
              </div>
            </div>
            <div
              className="flex-center me-3 sorted-item"
              onClick={handleSortClick}
            >
              <SortIcon
                className={`${PopupSortItem ? "color-blue" : "icon-color "}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${PopupSortItem ? "color-blue" : ""
                  }`}
              >
                Sort
              </div>
              {PopupSortItem && (
                <div className="popup-container-sort-new">
                  <div className="popup-header-sort"></div>
                  <div className="popup-content-breadcrumb">
                    <div className="sortable-item">
                      <span className="text">Alphabetical</span>
                      <span
                        className={`arrows ${sortOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item">
                      <span className="text">Date Created</span>
                      <span
                        className={`arrows ${sortDateOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortDateOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortDateOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item" onClick={handleLatestUpdate}>
                      <span
                        className={`text ${latestDateOrder === "latestDate" ? "color-blue" : ""
                          }`}
                      >
                        Last Updated
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex-center">
              <FaStar className="icon-color" />
              <Link to="/Favourites">
                <div className="sort-icons-cont mt-0">Favourites</div>
              </Link>
            </div>
          </>
        );
      case "Cards / Card Detailed View":
        return (
          <>
            <Link to="/edit-card">
              {/* <div className="d-flex">
                <div className="icon-new">
                  <MdEdit className="icon-color" />
                </div>
                <div className="sort-icons-cont">Edit</div>
              </div > */}
              <div className="flex-center">
                <IconButton className="icon-new icon-20px">
                  <EditIcon />
                </IconButton>
                <div className="sort-icons-cont mt-0">Edit</div>
              </div>
            </Link>
            <div
              className="flex-center"
              onClick={() => {
                setDuplicateCardopen(true);
              }}
            >
              <IconButton className="icon-new icon-20px">
                <DuplicateIcon
                  className={duplicateCardopen ? "color-blue" : "icon-color"}
                />
              </IconButton>
              <div
                className={`sort-icons-cont mt-0 ${duplicateCardopen ? "color-blue" : ""
                  }`}
              >
                Duplicate
              </div>
            </div>
            <div className="flex-center" onClick={handleClickEmail}>
              <IconButton className="icon-new icon-20px">
                <DigitalIcon className="icon-color" />
              </IconButton>
              <div className="sort-icons-cont mt-0">Email Signature</div>
            </div>
            <div className="flex-center" onClick={handleClickVirtualB}>
              <IconButton className="icon-new icon-20px">
                <VirtualIcon className="icon-color" />
              </IconButton>
              <div className="sort-icons-cont mt-0">Virtual Background</div>
            </div>

            <div
              className="flex-center sorted-item"
              onClick={handleOpenDownload}
            >
              <IconButton className="icon-new icon-20px">
                <FileDownloadIcon
                  className={OpenDownloadOption ? "color-blue" : "icon-color"}
                />
              </IconButton>
              <div
                className={`sort-icons-cont mt-0 ${OpenDownloadOption ? "color-blue" : ""
                  }`}
              >
                Download QR
              </div>
              {OpenDownloadOption && (
                <div className="popup-container-sort-new min-widthHeight-Dropdown">
                  <div className="popup-header-sort"></div>
                  <div
                    className="p-2 d-flex flex-column"
                    style={{ height: "100%" }}
                  >
                    <span
                      onClick={DownloadOptionPdf}
                      className="mx-2 d-flex align-items-center"
                      style={{ height: "50%" }}
                    >
                      <PDFicon className="me-2" /> PDF
                    </span>
                    <span
                      onClick={DownloadOptionImage}
                      className="mx-2 d-flex align-items-center"
                      style={{ height: "50%" }}
                    >
                      <PDFicon className="me-2" /> Image
                    </span>
                  </div>
                </div>
              )}
            </div>

            <div className="flex-center sorted-item">
              <MoreVertRoundedIcon
                onClick={handleClick}
                className="icon-color"
              />
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                }}
                transformOrigin={{
                  vertical: "bottom",
                }}
                sx={{
                  top: "105px",
                }}
              >
                <MenuItem onClick={() => setdeleteConfirm(true)}>
                  Delete
                </MenuItem>
                <MenuItem onClick={handleClose}>Configuration</MenuItem>
              </Menu>
            </div>
          </>
        );
      case "Cards / Create New card":
        return <></>;
      case "Cards / Edit card":
        return <></>;
      case "Cards / Favourites":
        return (
          <>
            <div className="div-min-max me-3 d-flex align-items-center justify-content-around">
              <div
                className={`iconBreadcrumb flex-center ms-0 ${quantity === 1 ? "disable" : ""
                  }`}
                onClick={handleDecrement}
              >
                <FaCircleMinus className="icon-color" />
              </div>
              <div className="div">{quantity}x</div>
              <div
                className={`iconBreadcrumb flex-center ms-0 ${quantity === 2 ? "disable" : ""
                  }`}
                onClick={handleIncrement}
              >
                <FaPlusCircle className="icon-color" />
              </div>
            </div>
            <div
              className="flex-center me-3 sorted-item"
              onClick={handleSortClick}
            >
              <SortIcon
                className={`${PopupSortItem ? "color-blue" : "icon-color "}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${PopupSortItem ? "color-blue" : ""
                  }`}
              >
                Sort
              </div>
              {PopupSortItem && (
                <div className="popup-container-sort-new">
                  <div className="popup-header-sort"></div>
                  <div className="popup-content-breadcrumb">
                    <div className="sortable-item">
                      <span className="text">Alphabetical</span>
                      <span
                        className={`arrows ${sortOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item">
                      <span className="text">Date Created</span>
                      <span
                        className={`arrows ${sortDateOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortDateOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortDateOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item" onClick={handleLatestUpdate}>
                      <span
                        className={`text ${latestDateOrder === "latestDate" ? "color-blue" : ""
                          }`}
                      >
                        Last Updated
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex-center">
              <FaStar color={"#FCB809"} />
              <Link to="/Favourites">
                <div className="sort-icons-cont mt-0">Favourites</div>
              </Link>
            </div>
          </>
        );
      case "Cards / Group Card":
        return (
          <>
            <FormControlLabel
              control={
                <Switch checked={isEnabledCCE} onChange={handleSwitchChange} />
              }
              label="CCE"
              sx={{ color: isEnabledCCE ? "#0044c6" : "#00000099" }}
            />
            <div
              className="flex-center"
              onClick={() => handleCardClick("cards")}
            >
              <IconButton className="icon-new icon-20px">
                <CardView
                  className={
                    GroupCardView === "cards" ? "color-blue" : "icon-color"
                  }
                />
              </IconButton>
              <div
                className={`sort-icons-cont mt-0 ${GroupCardView === "cards" ? "color-blue" : ""
                  }`}
              >
                Card View
              </div>
            </div>
            <div
              className="flex-center"
              onClick={() => handleCardClick("grouptree")}
            >
              <IconButton className="icon-new icon-20px">
                <GroupCard
                  className={
                    GroupCardView === "grouptree" ? "color-blue" : "icon-color"
                  }
                />
              </IconButton>
              <div
                className={`sort-icons-cont mt-0 ${GroupCardView === "grouptree" ? "color-blue" : ""
                  }`}
              >
                Tree View
              </div>
            </div>

            <div
              className="flex-center"
              onClick={() => handleCardClick("dashboard")}
            >
              <IconButton className="icon-new icon-20px">
                <Status
                  className={
                    GroupCardView === "dashboard" ? "color-blue" : "icon-color"
                  }
                />
              </IconButton>
              <div
                className={`sort-icons-cont mt-0 ${GroupCardView === "dashboard" ? "color-blue" : ""
                  }`}
              >
                Family Dashboard
              </div>
            </div>
          </>
        );
      case "Contacts":
        return (
          <>
            <Link
              to="/favourite_contacts"
              className="d-flex align-items-center"
            >
              <div className="flex-center me-3">
                <FaStar className="icon-color" />
                <div className="sort-icons-cont mt-0">Favourite Contact</div>
              </div>
            </Link>
            <div
              className="flex-center me-3 sorted-item"
              onClick={handleSortClick}
            >
              <SortIcon
                className={`${PopupSortItem ? "color-blue" : "icon-color "}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${PopupSortItem ? "color-blue" : ""
                  }`}
              >
                Sort
              </div>
              {PopupSortItem && (
                <div
                  className="popup-container-sort-new"
                  style={{ left: "-80px" }}
                >
                  <div className="popup-header-sort"></div>
                  <div className="popup-content-breadcrumb">
                    <div className="sortable-item">
                      <span className="text">Alphabetical</span>
                      <span
                        className={`arrows ${sortOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item">
                      <span className="text">Date Created</span>
                      <span
                        className={`arrows ${sortDateOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortDateOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortDateOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item" onClick={handleLatestUpdate}>
                      <span
                        className={`text ${latestDateOrder === "latestDate" ? "color-blue" : ""
                          }`}
                      >
                        Last Updated
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        );
      case "Contacts / All Contacts":
        return (
          <>
            {ContactView === "Grid View" && ( //for Grid View - this thing is not needed as three dot is in List
              <FormControlLabel
                control={
                  <Switch
                    checked={isEnabledCCE}
                    onChange={handleSwitchChange}
                  />
                }
                label="CCE"
                sx={{ color: isEnabledCCE ? "#0044c6" : "#00000099" }}
              />
            )}
            <Link
              to="/favourite_contacts"
              className="d-flex align-items-center"
            >
              <div className="flex-center me-3">
                <FaStar className="icon-color" />
                <div className="sort-icons-cont mt-0">Favourite Contact</div>
              </div>
            </Link>

            <div
              className="flex-center me-3 sorted-item"
              onClick={handleContactView}
            >
              <VisibilityIcon
                className={`${ListViewPopup ? "color-blue" : "icon-color "}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${ListViewPopup ? "color-blue" : ""
                  }`}
              >
                {ContactView}
              </div>

              {ListViewPopup && (
                <div
                  className="popup-container-sort-new"
                  style={{ left: "-50px" }}
                >
                  <div className="popup-header-sort"></div>
                  <div
                    className="popup-content-breadcrumb"
                    style={{ height: "unset", width: "125px" }}
                  >
                    <div
                      className="sortable-item"
                      onClick={() => {
                        handleChangeView("Grid View");
                      }}
                    >
                      <GridIconSymb
                        className={`mx-1 ${ContactView === "Grid View"
                          ? "color-blue"
                          : "icon-color"
                          }`}
                      />
                      <span
                        className={`text  ${ContactView === "Grid View" ? "color-blue" : ""
                          }`}
                      >
                        Grid View
                      </span>
                    </div>
                    <div
                      className="sortable-item"
                      onClick={() => {
                        handleChangeView("List View");
                      }}
                    >
                      <FormatListBulletedIcon
                        className={`mx-1 ${ContactView === "List View"
                          ? "color-blue"
                          : "icon-color"
                          }`}
                      />
                      <span
                        className={`text  ${ContactView === "List View" ? "color-blue" : ""
                          }`}
                      >
                        List View
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div
              className="flex-center me-3 sorted-item"
              onClick={handleSortClick}
            >
              <SortIcon
                className={`${PopupSortItem ? "color-blue" : "icon-color "}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${PopupSortItem ? "color-blue" : ""
                  }`}
              >
                Sort
              </div>
              {PopupSortItem && (
                <div
                  className="popup-container-sort-new"
                  style={{ left: "-80px" }}
                >
                  <div className="popup-header-sort"></div>
                  <div className="popup-content-breadcrumb">
                    <div className="sortable-item">
                      <span className="text">Alphabetical</span>
                      <span
                        className={`arrows ${sortOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item">
                      <span className="text">Date Created</span>
                      <span
                        className={`arrows ${sortDateOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortDateOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortDateOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item" onClick={handleLatestUpdate}>
                      <span
                        className={`text ${latestDateOrder === "latestDate" ? "color-blue" : ""
                          }`}
                      >
                        Last Updated
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex-center me-3">
              <FilterIcon className="icon-color" />
              <div className="sort-icons-cont mt-0">Filter</div>
            </div>
          </>
        );
      case "Contacts / Add to Contacts":
        return (
          <>
            <Link
              to="/favourite_contacts"
              className="d-flex align-items-center"
            >
              <div className="flex-center me-3">
                <FaStar className="icon-color" />
                <div className="sort-icons-cont mt-0">Favourite Contact</div>
              </div>
            </Link>
            <div className="flex-center me-3" onClick={handleClickFilter}>
              <FilterIcon
                className={`${FilterOpen ? "color-blue" : "icon-color "}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${FilterOpen ? "color-blue" : ""
                  }`}
              >
                Filter
              </div>
            </div>
          </>
        );
      case `All Groups / ${activeGrpName}`:
        return (
          <>
            {ContactView === "Grid View" && ( //for Grid View - this thing is not needed as three dot is in List
              <FormControlLabel
                control={
                  <Switch
                    checked={isEnabledCCE}
                    onChange={handleSwitchChange}
                  />
                }
                label="CCE"
                sx={{ color: isEnabledCCE ? "#0044c6" : "#00000099" }}
              />
            )}
            <Link
              to="/favourite_contacts"
              className="d-flex align-items-center"
            >
              <div className="flex-center me-3">
                <FaStar className="icon-color" />
                <div className="sort-icons-cont mt-0">Favourite Contact</div>
              </div>
            </Link>

            <div
              className="flex-center me-3 sorted-item"
              onClick={handleContactView}
            >
              <VisibilityIcon
                className={`${ListViewPopup ? "color-blue" : "icon-color "}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${ListViewPopup ? "color-blue" : ""
                  }`}
              >
                {ContactView}
              </div>

              {ListViewPopup && (
                <div
                  className="popup-container-sort-new"
                  style={{ left: "-50px" }}
                >
                  <div className="popup-header-sort"></div>
                  <div
                    className="popup-content-breadcrumb"
                    style={{ height: "unset", width: "125px" }}
                  >
                    <div
                      className="sortable-item"
                      onClick={() => {
                        handleChangeView("Grid View");
                      }}
                    >
                      <GridIconSymb
                        className={`mx-1 ${ContactView === "Grid View"
                          ? "color-blue"
                          : "icon-color"
                          }`}
                      />
                      <span
                        className={`text  ${ContactView === "Grid View" ? "color-blue" : ""
                          }`}
                      >
                        Grid View
                      </span>
                    </div>
                    <div
                      className="sortable-item"
                      onClick={() => {
                        handleChangeView("List View");
                      }}
                    >
                      <FormatListBulletedIcon
                        className={`mx-1 ${ContactView === "List View"
                          ? "color-blue"
                          : "icon-color"
                          }`}
                      />
                      <span
                        className={`text  ${ContactView === "List View" ? "color-blue" : ""
                          }`}
                      >
                        List View
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* <div
              className="flex-center me-3 sorted-item"
              onClick={handleSortClick}
            >
              <SortIcon
                className={`${PopupSortItem ? "color-blue" : "icon-color "}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${PopupSortItem ? "color-blue" : ""
                  }`}
              >
                Sort
              </div>
              {PopupSortItem && (
                <div
                  className="popup-container-sort-new"
                  style={{ left: "-80px" }}
                >
                  <div className="popup-header-sort"></div>
                  <div className="popup-content-breadcrumb">
                    <div className="sortable-item">
                      <span className="text">Alphabetical</span>
                      <span
                        className={`arrows ${sortOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item">
                      <span className="text">Date Created</span>
                      <span
                        className={`arrows ${sortDateOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortDateOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortDateOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item" onClick={handleLatestUpdate}>
                      <span
                        className={`text ${latestDateOrder === "latestDate" ? "color-blue" : ""
                          }`}
                      >
                        Last Updated
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div> */}

            {/* <div className="flex-center me-3">
              <FilterIcon className="icon-color" />
              <div className="sort-icons-cont mt-0">Filter</div>
            </div> */}
          </>
        );
      case `Contact / All Groups`:
        return (
          <>
            {ContactView === "Grid View" && ( //for Grid View - this thing is not needed as three dot is in List
              <FormControlLabel
                control={
                  <Switch
                    checked={isEnabledCCE}
                    onChange={handleSwitchChange}
                  />
                }
                label="CCE"
                sx={{ color: isEnabledCCE ? "#0044c6" : "#00000099" }}
              />
            )}
            <Link
              to="/favourite_contacts"
              className="d-flex align-items-center"
            >
              <div className="flex-center me-3">
                <FaStar className="icon-color" />
                <div className="sort-icons-cont mt-0">Favourite Contact</div>
              </div>
            </Link>

            {/* <div
              className="flex-center me-3 sorted-item"
              onClick={handleContactView}
            >
              <VisibilityIcon
                className={`${ListViewPopup ? "color-blue" : "icon-color "}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${ListViewPopup ? "color-blue" : ""
                  }`}
              >
                {ContactView}
              </div>

              {ListViewPopup && (
                <div
                  className="popup-container-sort-new"
                  style={{ left: "-50px" }}
                >
                  <div className="popup-header-sort"></div>
                  <div
                    className="popup-content-breadcrumb"
                    style={{ height: "unset", width: "125px" }}
                  >
                    <div
                      className="sortable-item"
                      onClick={() => {
                        handleChangeView("Grid View");
                      }}
                    >
                      <GridIconSymb
                        className={`mx-1 ${ContactView === "Grid View"
                          ? "color-blue"
                          : "icon-color"
                          }`}
                      />
                      <span
                        className={`text  ${ContactView === "Grid View" ? "color-blue" : ""
                          }`}
                      >
                        Grid View
                      </span>
                    </div>
                    <div
                      className="sortable-item"
                      onClick={() => {
                        handleChangeView("List View");
                      }}
                    >
                      <FormatListBulletedIcon
                        className={`mx-1 ${ContactView === "List View"
                          ? "color-blue"
                          : "icon-color"
                          }`}
                      />
                      <span
                        className={`text  ${ContactView === "List View" ? "color-blue" : ""
                          }`}
                      >
                        List View
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div> */}

            <div
              className="flex-center me-3 sorted-item"
              onClick={handleSortClick}
            >
              <SortIcon
                className={`${PopupSortItem ? "color-blue" : "icon-color "}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${PopupSortItem ? "color-blue" : ""
                  }`}
              >
                Sort
              </div>
              {PopupSortItem && (
                <div
                  className="popup-container-sort-new"
                  style={{ left: "-80px" }}
                >
                  <div className="popup-header-sort"></div>
                  <div className="popup-content-breadcrumb">
                    <div className="sortable-item">
                      <span className="text">Alphabetical</span>
                      <span
                        className={`arrows ${sortOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item">
                      <span className="text">Date Created</span>
                      <span
                        className={`arrows ${sortDateOrder === "ascending" ? "color-blue" : ""
                          }`}
                      >
                        <FaArrowUp
                          className={`arrow mx-1 ${sortDateOrder === "ascending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("ascending")}
                        />
                        <FaArrowDownLong
                          className={`arrow mx-1 ${sortDateOrder === "descending"
                            ? "color-blue"
                            : "icon-color"
                            }`}
                          onClick={() => setSortDateOrder("descending")}
                        />
                      </span>
                    </div>
                    <div className="sortable-item" onClick={handleLatestUpdate}>
                      <span
                        className={`text ${latestDateOrder === "latestDate" ? "color-blue" : ""
                          }`}
                      >
                        Last Updated
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* <div className="flex-center me-3">
              <FilterIcon className="icon-color" />
              <div className="sort-icons-cont mt-0">Filter</div>
            </div> */}
          </>
        );
      case "Contacts / Create Group Card":
        return (
          <Link to="/favourite_contacts" className="d-flex align-items-center">
            <div className="flex-center me-3">
              <FaStar className="icon-color" />
              <div className="sort-icons-cont mt-0">Favourite Contact</div>
            </div>
          </Link>
        );

      case "Applied Jobs":
        return (
          <Link
            to="/applicant-saved-jobs"
            className="d-flex align-items-center"
          >
            <div className="flex-center me-3">
              <BookmarkBorderIcon
                className={`${jobSortPopup ? "color-blue" : "icon-color"}`}
              />
              <div className="sort-icons-cont mt-0">Saved Jobs</div>
            </div>
          </Link>
        );

      case "Saved Jobs":
        return (
          <Link
            to="/applicant-saved-jobs"
            className="d-flex align-items-center"
          >
            <div className="flex-center me-3">
              <BookmarkBorderIcon
                className={`${jobSortPopup ? "color-blue" : "icon-color"}`}
              />
              <div className="sort-icons-cont mt-0">Saved Jobs</div>
            </div>
          </Link>
        );
      case "Compose Letter":
        return (
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="d-flex align-items-center">
              <div className="flex-center me-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`${jobSortPopup ? "color-blue" : "icon-color"}`}
                >
                  <rect x="3" y="3" width="7" height="7"></rect>
                  <rect x="14" y="3" width="7" height="7"></rect>
                  <rect x="3" y="14" width="7" height="7"></rect>
                  <rect x="14" y="14" width="7" height="7"></rect>
                </svg>
                <div className="sort-icons-cont mt-0">Templates</div>
              </div>
            </div>
            <div className="ms-3">
              <select
                className="form-select"
                style={{
                  fontSize: '14px',
                  padding: '6px 12px',
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0',
                  backgroundColor: 'white',
                  cursor: 'pointer'
                }}
                onChange={async (e) => {
                  const selectedTemplateId = e.target.value;
                  console.log('Selected Template ID:', letterHead)

                  if (selectedTemplateId) {
                    try {
                      // Find the full template object from letterHead array
                      const template = letterHead.find(t => t.template_id == selectedTemplateId);
                      // console.log("IIIIIIIIIIIIIIIIIIIIII", template)
                      setSelectedTemplate(template);

                      // Call your API with the template ID if needed
                      const response = await dispatch(getTemplateById(selectedTemplateId));
                      console.log('API response:', response);
                    } catch (error) {
                      console.error('Error calling API:', error);
                    }
                  } else {
                    setSelectedTemplate(null);
                  }
                }}
              >
                <option value="">Choose a template...</option>
                {letterHead && letterHead?.map((template) => (
                  <option key={template.template_id} value={template.template_id}>
                    📄 {template.template_name}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
              <Button
                sx={{
                  width: "214px",
                  height: "20px",
                  padding: "15px 25px",
                  backgroundColor: "#2ECC71",
                  fontWeight: 300,
                  size: "1rem",
                  color: "white",

                  "&:hover": {
                    backgroundColor: "#7bec77",
                  },
                }}
                // onClick={() => handleSendSignature(selectedTemplate)} 
                onClick={() => validateAndSubmit('SEND_FINAL')}
              // disabled={!selectedTemplate} 
              >
                Send Email
              </Button>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
              <Button
                sx={{
                  width: "214px",
                  height: "20px",
                  padding: "15px 25px",
                  backgroundColor: "#0044c6",
                  fontWeight: 300,
                  size: "1rem",
                  color: "white",

                  "&:hover": {
                    backgroundColor: "#0044c6",
                  },
                }}
                // onClick={() => handleSendSignature(selectedTemplate)} 
                onClick={() => validateAndSubmit('SEND_LINK')}
              // disabled={!selectedTemplate} 
              >
                Send Signature Link
              </Button>
            </div>
            <div>
              <Button
                sx={{
                  width: "214px",
                  height: "20px",
                  padding: "15px 25px",
                  backgroundColor: "#0044c6",
                  fontWeight: 300,
                  size: "1rem",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#0044c6",
                  },
                }}
                // onClick={() => handleSaveLetter(selectedTemplate)} 

                onClick={() => validateAndSubmit('SAVE')}
              // disabled={!selectedTemplate} 
              >
                Save Letter
              </Button>
            </div>
          </div>
        )
      case "Posted jobs":
        return (
          <>
            <div
              className="flex-center me-3 sorted-item"
              onClick={() => setJobViewPopup(!jobViewPopup)}
            >
              <VisibilityIcon
                className={`${jobViewPopup ? "color-blue" : "icon-color"}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${jobViewPopup ? "color-blue" : ""
                  }`}
              >
                {jobView}
              </div>

              {jobViewPopup && (
                <div
                  className="popup-container-sort-new"
                  style={{ left: "-50px" }}
                >
                  <div className="popup-header-sort"></div>
                  <div
                    className="popup-content-breadcrumb"
                    style={{ height: "unset", width: "125px" }}
                  >
                    <div
                      className="sortable-item"
                      onClick={() => {
                        // setJobView("Grid View");
                        dispatch(setJobViewMode("grid"));
                      }}
                    >
                      <GridIconSymb
                        className={`mx-1 ${jobView === "Grid View" ? "color-blue" : "icon-color"
                          }`}
                      />
                      <span
                        className={`text ${jobView === "Grid View" ? "color-blue" : ""
                          }`}
                      >
                        Grid View
                      </span>
                    </div>
                    <div
                      className="sortable-item"
                      onClick={() => {
                        // setJobView("List View");
                        dispatch(setJobViewMode("list"));
                      }}
                    >
                      <FormatListBulletedIcon
                        className={`mx-1 ${jobView === "List View" ? "color-blue" : "icon-color"
                          }`}
                      />
                      <span
                        className={`text ${jobView === "List View" ? "color-blue" : ""
                          }`}
                      >
                        List View
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* <div className="flex-center me-3 sorted-item"> */}
            {/* <BookmarkBorderIcon className={`${jobSortPopup ? "color-blue" : "icon-color"}`} /> */}
            {/* <FaStar className="icon-color" /> */}
            {/* <Link to="/favourite-jobs"> */}
            {/* <div className="sort-icons-cont mt-0">Save</div> */}
            {/* </Link> */}
            {/* <div className={`sort-icons-cont mt-0 ${jobSortPopup ? "color-blue" : ""}`}>
          Save
        </div> */}
            {/* {jobSortPopup && (
          <div className="popup-container-sort-new" style={{ left: "-80px" }}>
            <div className="popup-header-sort"></div>
            <div className="popup-content-breadcrumb">
              <div className="sortable-item">
                <span className="text">Job Title</span>
                <span className={`arrows ${jobSortOrder === "ascending" ? "color-blue" : ""}`}>
                  <FaArrowUp
                    className={`arrow mx-1 ${jobSortOrder === "ascending" ? "color-blue" : "icon-color"}`}
                    onClick={() => {
                      setJobSortOrder("ascending");
                      dispatch(sortJobs({ type: 'title', order: 'asc' }));
                    }}
                  />
                  <FaArrowDownLong
                    className={`arrow mx-1 ${jobSortOrder === "descending" ? "color-blue" : "icon-color"}`}
                    onClick={() => {
                      setJobSortOrder("descending");
                      dispatch(sortJobs({ type: 'title', order: 'desc' }));
                    }}
                  />
                </span>
              </div>
              <div className="sortable-item">
                <span className="text">Posted Date</span>
                <span className={`arrows ${jobDateOrder === "ascending" ? "color-blue" : ""}`}>
                  <FaArrowUp
                    className={`arrow mx-1 ${jobDateOrder === "ascending" ? "color-blue" : "icon-color"}`}
                    onClick={() => {
                      setJobDateOrder("ascending");
                      dispatch(sortJobs({ type: 'date', order: 'asc' }));
                    }}
                  />
                  <FaArrowDownLong
                    className={`arrow mx-1 ${jobDateOrder === "descending" ? "color-blue" : "icon-color"}`}
                    onClick={() => {
                      setJobDateOrder("descending");
                      dispatch(sortJobs({ type: 'date', order: 'desc' }));
                    }}
                  />
                </span>
              </div>
            </div>
          </div>
        )} */}
            {/* </div> */}
          </>
        );
      case "View All Jobs":
        return (
          <>
            <div
              className="flex-center me-3 sorted-item"
              onClick={() => setJobViewPopup(!jobViewPopup)}
            >
              <VisibilityIcon
                className={`${jobViewPopup ? "color-blue" : "icon-color"}`}
              />
              <div
                className={`sort-icons-cont mt-0 ${jobViewPopup ? "color-blue" : ""
                  }`}
              >
                {jobView}
              </div>

              {jobViewPopup && (
                <div
                  className="popup-container-sort-new"
                  style={{ left: "-50px" }}
                >
                  <div className="popup-header-sort"></div>
                  <div
                    className="popup-content-breadcrumb"
                    style={{ height: "unset", width: "125px" }}
                  >
                    <div
                      className="sortable-item"
                      onClick={() => {
                        // setJobView("Grid View");
                        dispatch(setJobViewMode("grid"));
                      }}
                    >
                      <GridIconSymb
                        className={`mx-1 ${jobView === "Grid View" ? "color-blue" : "icon-color"
                          }`}
                      />
                      <span
                        className={`text ${jobView === "Grid View" ? "color-blue" : ""
                          }`}
                      >
                        Grid View
                      </span>
                    </div>
                    <div
                      className="sortable-item"
                      onClick={() => {
                        // setJobView("List View");
                        dispatch(setJobViewMode("list"));
                      }}
                    >
                      <FormatListBulletedIcon
                        className={`mx-1 ${jobView === "List View" ? "color-blue" : "icon-color"
                          }`}
                      />
                      <span
                        className={`text ${jobView === "List View" ? "color-blue" : ""
                          }`}
                      >
                        List View
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex-center me-3 sorted-item">
              <BookmarkBorderIcon
                className={`${jobSortPopup ? "color-blue" : "icon-color"}`}
              />
              {/* <FaStar className="icon-color" /> */}
              <Link to="/favourite-jobs">
                <div className="sort-icons-cont mt-0">Save</div>
              </Link>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="breadcrumb-container">
        <Breadcrumbs aria-label="breadcrumb">
          <Link1 underline="hover" color="inherit" href="/home">
            Neoin
          </Link1>
          <Typography style={{ color: "#222223", fontWeight: 450 }}>
            {getBreadcrumbLabel()}
          </Typography>
        </Breadcrumbs>
        <div className="sort-icons status">
          {getRightSideIcon(getBreadcrumbLabel(true))}
        </div>
      </div>

      {deleteConfirm && (
        <div className="lightbox-overlay">
          <div className="lightbox-content p-4">
            <div className="d-flex align-items-center justify-content-between">
              <h6
                className="mb-0"
                style={{ fontSize: "16px", fontWeight: "bold", color: "black" }}
              >
                {CardName !== "Personal" ? (
                  <>Are you sure you want to delete your card?</>
                ) : (
                  <>Delete Card</>
                )}
              </h6>
              <IconButton onClick={() => setdeleteConfirm(false)}>
                <CloseRoundedIcon />
              </IconButton>
            </div>

            {CardName !== "Personal" ? (
              <>
                <Typography variant="body2" className="text-muted">
                  This action cannot be undone. All information associated with
                  this will be lost.
                </Typography>
                <div className="mt-3">
                  <Grid container>
                    <Grid item xs={12}>
                      <TextField
                        label="Type Password"
                        fullWidth
                        type="password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                </div>
                {errorMessage && (
                  <Typography variant="body2" color="error">
                    {errorMessage}
                  </Typography>
                )}
                <div className="d-flex justify-content-end">
                  <Button
                    onClick={() => setdeleteConfirm(false)}
                    className="mx-2 mt-2"
                    style={{ color: "#0044c6" }}
                  >
                    CANCEL
                  </Button>
                  <Button
                    onClick={handleDeleteCard}
                    className="delete-button_configuration mt-2"
                  >
                    DELETE
                  </Button>
                </div>{" "}
              </>
            ) : (
              <>
                <p className="heading-fav-content text-left m-0 pt-2">
                  Sorry! You Can't Delete Personal Card
                </p>
              </>
            )}
          </div>
        </div>
      )}

      {duplicateCardopen && (
        <div className="lightbox-overlay">
          <div className="lightbox-content p-4">
            <div className="d-flex align-items-center justify-content-between">
              <h5
                className="mb-0"
                style={{ fontSize: "18px", fontWeight: "bold", color: "black" }}
              >
                Duplicate your card
              </h5>
              <IconButton onClick={() => setDuplicateCardopen(false)}>
                <CloseRoundedIcon />
              </IconButton>
            </div>
            <Typography variant="body2" className="text-muted">
              Duplicate your card and personalize it to your preferences!
            </Typography>

            <div className="mt-3">
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    label="Name Your Card"
                    fullWidth
                    value={newCardName}
                    onChange={(e) => {
                      setNewCardName(e.target.value);
                      setErrorMessage2("");
                    }}
                  />
                </Grid>
              </Grid>
            </div>

            {errorMessage2 && (
              <Typography variant="body2" color="error">
                {errorMessage2}
              </Typography>
            )}

            <div
              className="d-flex justify-content-end"
              style={{ marginTop: "32px" }}
            >
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0044C6" }}
                onClick={handleDuplicateCard}
              >
                DUPLICATE
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewBreadcrumb;
